
import Vue from "vue";
import Breadcrumb from "./components/Breadcrumb.vue";
import AppMain from "./components/AppMain.vue";
import Navbar from "./components/Navbar.vue";
import AuthenticationService from "../security/AuthenticationService";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import { SystemModule, AccountModule, FacilityModule, OrderModule } from "@/store/modules";
import BarcodeManufacturerModule from "@/store/modules/barcodeSystem/barcodeManufacturer";
import BarcodeCompanyModule from "@/store/modules/barcodeSystem/barcodeCompany";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import BarcodeItemTypeModule from "@/store/modules/barcodeSystem/itemType";
import * as Sentry from "@sentry/browser";
import LogRocket from "logrocket";
import { Vue as VueIntegration } from "@sentry/integrations";
import version from "../version";

@Component({
  components: {
    AppMain,
    Navbar,
    Breadcrumb
  }
})
export default class Layout extends Vue {
  accountModule: AccountModule = getModule(AccountModule);
  orderModule: OrderModule = getModule(OrderModule);
  systemModule: SystemModule = getModule(SystemModule);
  facilityModule: FacilityModule = getModule(FacilityModule);
  barcodeCompanyModule: BarcodeCompanyModule = getModule(BarcodeCompanyModule);
  barcodeSystemModule: BarcodeSystemModule = getModule(BarcodeSystemModule);
  barcodeManufacturerModule: BarcodeManufacturerModule = getModule(BarcodeManufacturerModule);
  barcodeItemTypeModule: BarcodeItemTypeModule = getModule(BarcodeItemTypeModule);

  loading: boolean = false;
  isLoggedIn: boolean = false;
  validUser: boolean = false;
  user: any = {};

  async created() {
    this.loading = true;

    const result = await AuthenticationService.getUser(false);

    if (result) {
      try {
        this.user = await this.accountModule.getUserDetails();

        Sentry.init({
          release: version.number,
          environment: process.env.VUE_APP_SENTRY_ENV,
          dsn: process.env.VUE_APP_SENTRY_DSN,
          debug: false,
          integrations: [new VueIntegration({ Vue: Vue, attachProps: true, logErrors: true })]
        });

        Sentry.setUser({ username: this.user.name, email: this.user.email });
        if (process.env.NODE_ENV && process.env.VUE_APP_LOGROCKET_ENABLED == 1) {
          LogRocket.init(process.env.VUE_APP_LOGROCKET_PROJECT_ID);
          LogRocket.identify(this.user.name);
          LogRocket.getSessionURL(sessionURL => {
            Sentry.configureScope(scope => {
              scope.setExtra("sessionURL", sessionURL);
            });
          });
        }

        this.isLoggedIn = true;
        this.validUser = true;

        await this.systemModule.loadDeliveryFors();
        await this.systemModule.loadFacilities();
        await this.systemModule.loadDeliveryTypes();
        await this.systemModule.loadAgentDeliveryTypesForStartup();
        await this.systemModule.loadReferenceTypes();
        await this.systemModule.loadChargeTypes(0);
        await this.systemModule.loadStates();
        await this.systemModule.loadZip3Overrides();
        await this.systemModule.loadCommodityFixForOptions();
        await this.systemModule.loadOrderStatuses();
        await this.systemModule.loadTruckStatuses();
        await this.orderModule.loadAlertTypes();
        await this.accountModule.ensureLoadColumnPreferencesForTable("dispatchTable");
        await this.accountModule.loadUserSettings("homeFacilities");
        await this.accountModule.loadUserSettings("truckImportFormat");
        await this.accountModule.loadUserSettings("truckImportFacilityCode");
        await this.accountModule.loadUserSettings("deliveryExportFormat");
        await this.accountModule.loadUserSettings("deliveryExportFacilityCode");
        await this.accountModule.loadUserSettings("truckFilterFacilityCode");
        await this.accountModule.loadUserSettings("defaultSavedSearches");
        await this.accountModule.loadUserSettings("defaultSearchSubscriptions");
        await this.accountModule.loadUserSettings("barcodeSystemCurrentFacilityCode");
        await this.facilityModule.getFacilitySavedOrderSearches();

        //Barcode System
        await this.barcodeCompanyModule.loadCompanies();
        await this.barcodeCompanyModule.loadBillTos();
        await this.barcodeManufacturerModule.loadManufacturers();
        await this.barcodeItemTypeModule.loadItemTypes();
        await this.barcodeSystemModule.loadBarcodeOrderStatuses();
        await this.barcodeSystemModule.loadBarcodeOrderItemStatuses();
        await this.barcodeSystemModule.loadStockOrderStatuses();
        await this.barcodeSystemModule.loadStockOrderItemStatuses();
        await this.barcodeSystemModule.loadLoadStatuses();
        await this.barcodeSystemModule.loadInventoryItemStatuses();
        await this.barcodeSystemModule.loadDamageCodes();
        await this.barcodeSystemModule.loadReturnReasonCodes();
        await this.barcodeSystemModule.loadWarehouseFacilities();
        await this.barcodeSystemModule.loadWarehouseLocationCategories();

        if(this.systemModule.facilities && this.systemModule.facilities.length == 1)
        {
          await this.barcodeSystemModule.setCurrentFacilityCode(this.systemModule.facilities[0].facilityCode);
        }
        else if(this.accountModule.barcodeSystemCurrentFacilityCodeUserSettings && this.accountModule.barcodeSystemCurrentFacilityCodeUserSettings.length > 0)
        {
          await this.barcodeSystemModule.setCurrentFacilityCode(this.accountModule.barcodeSystemCurrentFacilityCodeUserSettings[0]);
        }
        else if(this.systemModule.facilities && this.systemModule.facilities.length == 1)
        {
          await this.barcodeSystemModule.setCurrentFacilityCode(this.systemModule.facilities[0].facilityCode);
        }

        this.loading = false;
      } catch (ex) {
        this.validUser = false;
        this.isLoggedIn = true;
      }
    }

    this.loading = false;
  }
}
